'use strict';

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Any = require('./any');
var Common = require('../common');
var Compile = require('../compile');
var Errors = require('../errors');
var Ref = require('../ref');
var internals = {};
module.exports = Any.extend({
  type: 'alternatives',
  flags: {
    match: {
      default: 'any'
    } // 'any', 'one', 'all'
  },
  terms: {
    matches: {
      init: [],
      register: Ref.toSibling
    }
  },
  args: function args(schema) {
    for (var _len = arguments.length, schemas = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      schemas[_key - 1] = arguments[_key];
    }
    if (schemas.length === 1) {
      if (Array.isArray(schemas[0])) {
        return schema.try.apply(schema, _toConsumableArray(schemas[0]));
      }
    }
    return schema.try.apply(schema, schemas);
  },
  validate: function validate(value, helpers) {
    var schema = helpers.schema,
      error = helpers.error,
      state = helpers.state,
      prefs = helpers.prefs; // Match all or one
    if (schema._flags.match) {
      var hits = 0;
      var matched;
      for (var i = 0; i < schema.$_terms.matches.length; ++i) {
        var item = schema.$_terms.matches[i];
        var localState = state.nest(item.schema, "match.".concat(i));
        localState.snapshot();
        var result = item.schema.$_validate(value, localState, prefs);
        if (!result.errors) {
          ++hits;
          matched = result.value;
        } else {
          localState.restore();
        }
      }
      if (!hits) {
        return {
          errors: error('alternatives.any')
        };
      }
      if (schema._flags.match === 'one') {
        return hits === 1 ? {
          value: matched
        } : {
          errors: error('alternatives.one')
        };
      }
      return hits === schema.$_terms.matches.length ? {
        value: value
      } : {
        errors: error('alternatives.all')
      };
    }

    // Match any

    var errors = [];
    for (var _i = 0; _i < schema.$_terms.matches.length; ++_i) {
      var _item = schema.$_terms.matches[_i];

      // Try

      if (_item.schema) {
        var _localState = state.nest(_item.schema, "match.".concat(_i));
        _localState.snapshot();
        var _result = _item.schema.$_validate(value, _localState, prefs);
        if (!_result.errors) {
          return _result;
        }
        _localState.restore();
        errors.push({
          schema: _item.schema,
          reports: _result.errors
        });
        continue;
      }

      // Conditional

      var input = _item.ref ? _item.ref.resolve(value, state, prefs) : value;
      var tests = _item.is ? [_item] : _item.switch;
      for (var j = 0; j < tests.length; ++j) {
        var test = tests[j];
        var is = test.is,
          then = test.then,
          otherwise = test.otherwise;
        var id = "match.".concat(_i).concat(_item.switch ? '.' + j : '');
        if (!is.$_match(input, state.nest(is, "".concat(id, ".is")), prefs)) {
          if (otherwise) {
            return otherwise.$_validate(value, state.nest(otherwise, "".concat(id, ".otherwise")), prefs);
          }
        } else if (then) {
          return then.$_validate(value, state.nest(then, "".concat(id, ".then")), prefs);
        }
      }
    }
    return internals.errors(errors, helpers);
  },
  rules: {
    conditional: {
      method: function method(condition, options) {
        Assert(!this._flags._endedSwitch, 'Unreachable condition');
        Assert(!this._flags.match, 'Cannot combine match mode', this._flags.match, 'with conditional rule');
        Assert(options.break === undefined, 'Cannot use break option with alternatives conditional');
        var obj = this.clone();
        var match = Compile.when(obj, condition, options);
        var conditions = match.is ? [match] : match.switch;
        var _iterator = _createForOfIteratorHelper(conditions),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (item.then && item.otherwise) {
              obj.$_setFlag('_endedSwitch', true, {
                clone: false
              });
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        obj.$_terms.matches.push(match);
        return obj.$_mutateRebuild();
      }
    },
    match: {
      method: function method(mode) {
        Assert(['any', 'one', 'all'].includes(mode), 'Invalid alternatives match mode', mode);
        if (mode !== 'any') {
          var _iterator2 = _createForOfIteratorHelper(this.$_terms.matches),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var match = _step2.value;
              Assert(match.schema, 'Cannot combine match mode', mode, 'with conditional rules');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        return this.$_setFlag('match', mode);
      }
    },
    try: {
      method: function method() {
        for (var _len2 = arguments.length, schemas = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          schemas[_key2] = arguments[_key2];
        }
        Assert(schemas.length, 'Missing alternative schemas');
        Common.verifyFlat(schemas, 'try');
        Assert(!this._flags._endedSwitch, 'Unreachable condition');
        var obj = this.clone();
        for (var _i2 = 0, _schemas = schemas; _i2 < _schemas.length; _i2++) {
          var schema = _schemas[_i2];
          obj.$_terms.matches.push({
            schema: obj.$_compile(schema)
          });
        }
        return obj.$_mutateRebuild();
      }
    }
  },
  overrides: {
    label: function label(name) {
      var obj = this.$_super.label(name);
      var each = function each(item, source) {
        return source.path[0] !== 'is' ? item.label(name) : undefined;
      };
      return obj.$_modify({
        each: each,
        ref: false
      });
    }
  },
  rebuild: function rebuild(schema) {
    // Flag when an alternative type is an array

    var each = function each(item) {
      if (Common.isSchema(item) && item.type === 'array') {
        schema.$_setFlag('_arrayItems', true, {
          clone: false
        });
      }
    };
    schema.$_modify({
      each: each
    });
  },
  manifest: {
    build: function build(obj, desc) {
      if (desc.matches) {
        var _iterator3 = _createForOfIteratorHelper(desc.matches),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var match = _step3.value;
            var schema = match.schema,
              ref = match.ref,
              is = match.is,
              not = match.not,
              then = match.then,
              otherwise = match.otherwise;
            if (schema) {
              obj = obj.try(schema);
            } else if (ref) {
              obj = obj.conditional(ref, {
                is: is,
                then: then,
                not: not,
                otherwise: otherwise,
                switch: match.switch
              });
            } else {
              obj = obj.conditional(is, {
                then: then,
                otherwise: otherwise
              });
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return obj;
    }
  },
  messages: {
    'alternatives.all': '{{#label}} does not match all of the required types',
    'alternatives.any': '{{#label}} does not match any of the allowed types',
    'alternatives.match': '{{#label}} does not match any of the allowed types',
    'alternatives.one': '{{#label}} matches more than one allowed type',
    'alternatives.types': '{{#label}} must be one of {{#types}}'
  }
});

// Helpers

internals.errors = function (failures, _ref) {
  var error = _ref.error,
    state = _ref.state;
  // Nothing matched due to type criteria rules

  if (!failures.length) {
    return {
      errors: error('alternatives.any')
    };
  }

  // Single error

  if (failures.length === 1) {
    return {
      errors: failures[0].reports
    };
  }

  // Analyze reasons

  var valids = new Set();
  var complex = [];
  var _iterator4 = _createForOfIteratorHelper(failures),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _step4.value,
        reports = _step4$value.reports,
        schema = _step4$value.schema;
      // Multiple errors (!abortEarly)

      if (reports.length > 1) {
        return internals.unmatched(failures, error);
      }

      // Custom error

      var report = reports[0];
      if (report instanceof Errors.Report === false) {
        return internals.unmatched(failures, error);
      }

      // Internal object or array error

      if (report.state.path.length !== state.path.length) {
        complex.push({
          type: schema.type,
          report: report
        });
        continue;
      }

      // Valids

      if (report.code === 'any.only') {
        var _iterator5 = _createForOfIteratorHelper(report.local.valids),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var valid = _step5.value;
            valids.add(valid);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        continue;
      }

      // Base type
      var _report$code$split = report.code.split('.'),
        _report$code$split2 = _slicedToArray(_report$code$split, 2),
        type = _report$code$split2[0],
        code = _report$code$split2[1];
      if (code !== 'base') {
        complex.push({
          type: schema.type,
          report: report
        });
        continue;
      }
      valids.add(type);
    }

    // All errors are base types or valids
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  if (!complex.length) {
    return {
      errors: error('alternatives.types', {
        types: _toConsumableArray(valids)
      })
    };
  }

  // Single complex error

  if (complex.length === 1) {
    return {
      errors: complex[0].report
    };
  }
  return internals.unmatched(failures, error);
};
internals.unmatched = function (failures, error) {
  var errors = [];
  var _iterator6 = _createForOfIteratorHelper(failures),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var failure = _step6.value;
      errors.push.apply(errors, _toConsumableArray(failure.reports));
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return {
    errors: error('alternatives.match', Errors.details(errors, {
      override: false
    }))
  };
};